import config from 'src/config';
import api from 'src/services/httpService';
import storage from 'src/storage';

class Admin {
  static getAdmins(queries) {
    const axiosConfig = {
      headers: {
        Authorization: `Bearer ${storage.getToken()}`
      }
    };
    const searchParams = new URLSearchParams(queries);
    // console.log(axiosConfig);
    return api.get(
      `${config.rootUrl}/admin/staff/?${searchParams}`,
      axiosConfig
    );
  }

  static getAdmin(id) {
    const axiosConfig = {
      headers: {
        Authorization: `Bearer ${storage.getToken()}`
      }
    };
    return api.get(`${config.rootUrl}/admin/staff/${id}`, axiosConfig);
  }

  static async getSettings() {
    const axiosConfig = {
      headers: {
        Authorization: `Bearer ${storage.getToken()}`
      }
    };
    return api
      .get(`${config.rootUrl}/admin/settings`, axiosConfig)
      .then(({ data }) => data);
  }

  static async updateSettings(settings) {
    const axiosConfig = {
      headers: {
        Authorization: `Bearer ${storage.getToken()}`
      }
    };
    return api
      .patch(`${config.rootUrl}/admin/settings`, settings, axiosConfig)
      .then(({ data }) => data);
  }

  // NOTE: unused & divergent. CustomerView calls src/api/user.js's verifyUser
  // (forwards the full payload incl. idVerify/licenceVerify); this one only
  // forwards driverVerify/riderVerify and drops idVerify. No importers (grep).
  static verifyUser(id, { driverVerify, riderVerify }) {
    const axiosConfig = {
      headers: {
        Authorization: `Bearer ${storage.getToken()}`
      }
    };
    const data = {};

    if (typeof driverVerify !== 'undefined') {
      data.driverVerify = driverVerify;
    }

    if (typeof riderVerify !== 'undefined') {
      data.riderVerify = riderVerify;
    }
    return api.post(
      `${config.rootUrl}/admin/user/${id}/verify`,
      data,
      axiosConfig
    );
  }

  //  trips
  static cancelTrip(id) {
    const axiosConfig = {
      headers: {
        Authorization: `Bearer ${storage.getToken()}`
      }
    };
    return api
      .patch(`${config.rootUrl}/admin/trip/${id}/cancel`, null, axiosConfig)
      .then(({ data }) => data);
  }

  //  cancel booking
  static cancelBooking(id) {
    const axiosConfig = {
      headers: {
        Authorization: `Bearer ${storage.getToken()}`
      }
    };
    return api
      .patch(`${config.rootUrl}/admin/booking/${id}/cancel`, null, axiosConfig)
      .then(({ data }) => data);
  }

  // refunds
  static getRefunds(query) {
    const axiosConfig = {
      headers: {
        Authorization: `Bearer ${storage.getToken()}`
      },
      params: query
    };
    return api
      .get(`${config.rootUrl}/admin/refund`, axiosConfig)
      .then(({ data }) => data);
  }

  // accept refund request
  static approveRefundRequest(bookingId) {
    const axiosConfig = {
      headers: {
        Authorization: `Bearer ${storage.getToken()}`
      }
    };
    return api
      .post(
        `${config.rootUrl}/admin/refund/${bookingId}/authorize`,
        null,
        axiosConfig
      )
      .then(({ data }) => data);
  }

  // Verification reviews worklist (ISSUE-0035)
  static getVerificationReviews(query) {
    const axiosConfig = {
      headers: {
        Authorization: `Bearer ${storage.getToken()}`
      },
      params: query
    };
    return api
      .get(`${config.rootUrl}/admin/verification-reviews`, axiosConfig)
      .then(({ data }) => data);
  }

  // Admin edit self
  static adminEditSelf(payload) {
    const axiosConfig = {
      headers: {
        Authorization: `Bearer ${storage.getToken()}`
      }
    };
    return api
      .patch(`${config.rootUrl}/admin`, payload, axiosConfig)
      .then(({ data }) => data);
  }

  // Super admin edit admin
  static superAdminEditAdmin(id, payload) {
    const axiosConfig = {
      headers: {
        Authorization: `Bearer ${storage.getToken()}`
      }
    };
    return api
      .patch(`${config.rootUrl}/admin/staff/${id}/edit`, payload, axiosConfig)
      .then(({ data }) => data);
  }

  // Super admin sent reset password link admin
  static superAdminResetAdminPassword(payload) {
    const axiosConfig = {
      headers: {
        Authorization: `Bearer ${storage.getToken()}`
      }
    };
    return api
      .post(`${config.rootUrl}/auth/admin/forgot`, payload, axiosConfig)
      .then(({ data }) => data);
  }

  // delete deactivated admin
  static deleteDeactivatedAdmin(id) {
    const axiosConfig = {
      headers: {
        Authorization: `Bearer ${storage.getToken()}`
      }
    };
    return api.delete(`${config.rootUrl}/admin/staff/${id}`, axiosConfig);
  }
}

export default Admin;
